import React, {Component} from 'react';
import {Switch} from "./buttons/Swtich";
import {YesNoModal} from "./elements/YesNoModal";
import { withTranslation } from 'react-i18next';

class StatusTogglClass extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.state = {
            active: props.active
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({active: nextProps.active})
    }

    status() {
        const { t } = this.props;
        if (this.state.active) {
            return t('status.active')
        } else {
            return t('status.inactive')
        }
    }

    handleChange(event) {
        const isActive = event.target.checked;
        this.setState({active: isActive});
        this.props.onChange(isActive);
    }

    handleDelete() {
        if (this.props.onDelete != null) {
            this.props.onDelete();
        }
    }

    renderDeleteButton() {
        if (this.props.onDelete == null || this.state.active)
            return null;

        return (
            <span style={{marginLeft: "5px"}}>
                <YesNoModal onYesAnswer={this.handleDelete}
                            title={this.props.title}
                            message={this.props.message}
                            question={this.props.question}
                            buttonClassName={""}
                            buttonText={""}
                            buttonIconName={"trash"}
                />
            </span>)
    }

    render() {
        return (
            <div className="status-toggl">
                <Switch onChange={this.handleChange} checked={this.state.active}/>
                    <p className="status-label">{this.status()}</p>
                {this.renderDeleteButton()}
            </div>
        )
    }
}

export const StatusToggl = withTranslation()(StatusTogglClass);

